import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {CreateProductsCsv as CreateProductsCsvMutation} from 'nutshell-graphql-types';

import CREATE_PRODUCTS_CSV from '../mutations/create-products-csv.graphql';

export const useCreateProductsCsv = (): {
    createProductsCsv: () => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [createProductsCsv, {loading, error}] = useMutation<
        CreateProductsCsvMutation,
        Record<any, any>
    >(CREATE_PRODUCTS_CSV);

    return {
        createProductsCsv: () => createProductsCsv(),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
